export const modalTranslations = {
	finalizedApplication: {
		body: {
			sv: "Du behöver inte göra något mer utan vi hör av oss när allt är klart. Har du frågor kan du mejla **hej.bank@svea.com** eller ringa **+46 86169900**",
		},
		title: {
			sv: "Nu är din ansökan klar",
		},
		close: {
			sv: "Gå till sammanfattning",
		},
		logout: {
			sv: "Jag förstår, logga ut",
		},
	},
	finalizeMissingBo: {
		body: {
			sv: "Din ansökan är sparad. Innan den kan handläggas på banken behöver du uppdatera verklig huvudman hos Bolagsverket.",
		},
		title: {
			sv: "Uppdatera verklig huvudman",
		},
	},
	missingCreditAssessment: {
		body: {
			sv: "För att gå vidare behöver vi göra en ny kreditupplysning på ditt företag.",
		},
		heading: {
			sv: "Ny kreditupplysning",
		},
		confirmButton: {
			sv: "Det är okej",
		},
	},
};
